<template>
  <section class="support">
    <h2 class="wd-title">
      <span class="hl">No estás solo</span> estamos contigo en cada paso.
    </h2>
    <div class="support__rows">
      <p v-for="message in messages" :key="message.desktop" class="support__row wd-body">
        <span class="support__check"><img :src="checkIcon" alt="" aria-hidden="true"></span>
        <span>
          <span class="only-d">{{ message.desktop }}</span>
          <span class="only-tm">{{ message.compact }}</span>
        </span>
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import checkIcon from '../../../assets/bienvenida-desktop/check.svg'

// Desktop usa un copy más corto que tablet y mobile (Figma)
const messages = [
  {
    desktop: 'A partir de ahora, cuentas con un equipo que te acompaña en cada etapa.',
    compact: 'A partir de ahora, cuentas con un equipo que te acompaña durante todo tu proceso.'
  },
  {
    desktop: 'Nuestro objetivo es que siempre tengas claridad sobre qué sigue y cómo avanzar.',
    compact: 'Nuestro objetivo es que siempre tengas claridad sobre qué sigue y cómo avanzar.'
  },
  {
    desktop: 'Si tienes dudas o quieres acelerar tu proceso, estamos aquí para ayudarte.',
    compact: 'Si tienes dudas, necesitas orientación o quieres acelerar tu proceso, estamos aquí para ayudarte.'
  }
]
</script>

<style scoped>
.support {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-6);
  padding: var(--ds-space-6) var(--ds-space-5);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 24px;
}
.support__rows { display: flex; flex-direction: column; gap: var(--ds-space-6); }
.support__row { display: flex; align-items: center; gap: var(--ds-space-3); }
.support__check {
  display: flex;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
.support__check img { width: 21px; height: 16px; }

@media (max-width: 1024px) {
  .support__rows { gap: var(--ds-space-5); }
  .support__row { min-height: 48px; }
}

@media (max-width: 599px) {
  .support { gap: var(--ds-space-5); padding: var(--ds-space-5) var(--ds-space-4); }
}
</style>
